export default function () {
  const { $yotpo } = useNuxtApp()

  onMounted(() => {
    $yotpo.addCallback(() => {
      $yotpo.refresh()
    })
    $yotpo.load()
  })
}
